

import { useContext, useEffect, useRef, useState } from 'react'


import 'bootstrap-daterangepicker/daterangepicker.css';
import { UsersContext } from '../../context/users/UserContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';
import { BanksContext } from '../../context/bank/BankContext';
import Message from '../../components/ui/Message';
import { AuthContext } from '../../context/auth';





export const UserPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [isFormValid, setIsFormValid] = useState(false);
    const { banks } = useContext(BanksContext)
    const { groups, merchants, addUser, updateUser, loadPayfacs, clearSuggestions, suggestions } = useContext(UsersContext);
    const [existUserMsg, setExistUserMsg] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const { user: loggedUser } = useContext(AuthContext);
    const [payfacs, setPayfacs] = useState([]);

    var user;



    if (state) {
        user = state.user;
        user.isUserPayfac = user.isPayfac;
        user.bank_id = user.fiId ? user.fiId : -1;
    } else {
        user = {
            user_id: -1,
            user_name: '',
            email: '',
            name: '',
            lastname: '',
            bank_id: -1,
            isUserPayfac: 'N',
            payfacId: -1
        }
    }


    const { formState, onInputChange } = useForm(user);

    var { user_id, user_name, email, name, lastname, bank_id } = formState

    useEffect(() => {
        loadPayfacs().then(pfs => setPayfacs(pfs));
    }, [])

    useEffect(() => {
        //var formValid = false;

        var formValid = (
            user_name.length > 0
            && name.length
            && email.length
            && isValidEmail(email)

        );
        setIsFormValid(formValid);
    }, [user_name, name, email, bank_id])


    const handleSave = async () => {
        var resp = "";

        var user = formState;
        user.bank_id = bank_id;

        if (user.isUserPayfac == 'Y' && user.payfacId == -1) {
            setErrorMessage("Si el usuario es para un Payfac, debe seleccionar un Payfac.");
            return;
        }

        user.isPayfac = user.isUserPayfac;

        if (user.isUserPayfac == 'N') {
            user.payfacId = undefined;
        }


        if (user_id > 0) {
            resp = await updateUser(user);
        } else {
            resp = await addUser(user);
        }
        if (resp == "success") {
            setSuccessMessage(user_id > 0 ? "Usuario actualizado correctamente" : "Usuario creado correctamente.");
        } else {
            setErrorMessage(resp);
            setExistUserMsg(resp);
        }
    }

    const handleSuggestion = (suggestion: string) => {

        onInputChange({
            target: {
                name: 'user_name',
                value: suggestion
            },
        })
        clearSuggestions();
    }

    const onChangeUserName = ({ target }) => {
        onInputChange({ target })
        clearSuggestions();
    }

    const removeSucessMessage = () => {
        setSuccessMessage('');
        navigate(-1);
    }

    const removeError = () => {
        setErrorMessage('');
    }


    const isValidEmail = (email) => {

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }



    return (

        <div className='container d-flex align-items-center justify-content-center mt-5' style={styles.container}>


            <div className='col-md-6'>
                <h3>{user_id > 0 ? 'Actualizar usuario' : 'Crear usuario'}</h3>
                <hr />

                <form className="row g-3 " >


                    <div className="mb-3">
                        <label htmlFor="userNameInput" className="form-label">Usuario</label>
                        <input
                            id='userNameInput'
                            type="text"
                            className={`form-control  ${user_id < 0 && (user_name ? 'is-valid' : 'is-invalid')}`}
                            placeholder="Usuario"
                            name="user_name"
                            value={user_name}
                            onChange={onChangeUserName}
                            autoComplete='off'
                            disabled={user_id > 0}
                            required={user_id < 0}
                        />

                        {
                            suggestions.length > 0 ?
                                <>
                                    <span style={{ marginLeft: '5px', color: '#bd0404' }}> {existUserMsg}</span><br />
                                    {
                                        suggestions.map(suggestion => (
                                            <span
                                                key={suggestion}
                                                className='rounded-pill btn  btn-outline-secondary m-1'
                                                onClick={() => handleSuggestion(suggestion)}
                                                style={{ padding: '3px 15px' }}  >{suggestion}</span>
                                        ))
                                    }
                                </>
                                : ''
                        }
                    </div>

                    <div className="mb-3">
                        <label htmlFor="nameInput" className="form-label">Nombre</label>
                        <input
                            id='nameInput'
                            type="text"
                            className={`form-control ${name ? 'is-valid' : 'is-invalid'}`}
                            placeholder="Nombre"
                            name="name"
                            value={name}
                            onChange={onInputChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="lastnameInput" className="form-label">Apellidos</label>
                        <input
                            id='lastnameInput'
                            type="text"
                            className={`form-control ${lastname ? 'is-valid' : 'is-invalid'}`}
                            placeholder="Apellidos"
                            name="lastname"
                            value={lastname}
                            onChange={onInputChange}
                            required
                        />
                    </div>


                    <div className="mb-3">
                        <label htmlFor="emailInput" className="form-label">Correo</label>
                        <input
                            id='emailInput'
                            type="email"
                            className={`form-control ${email && isValidEmail(email) ? 'is-valid' : 'is-invalid'}`}
                            placeholder="Correo"
                            name="email"
                            value={email}
                            onChange={onInputChange}
                            required
                        />
                    </div>



                    <div className={`"mb-3 " ${loggedUser.groups[0].group_name == 'Administrator' ? '' : 'visually-hidden'}`}>
                        <label htmlFor="bankSelect" className="form-label">Banco</label>
                        <select id='bankSelect' className="form-select" name='bank_id' value={bank_id} onChange={onInputChange} disabled={user_id > 0}>
                            <option key={0} value={-1} >Seleccione una opción</option>
                            {banks.length > 0
                                ?
                                banks.map(bank => (
                                    <option key={bank.id} value={bank.id} selected={bank.id == user.bank_id}>{bank.name}</option>
                                ))
                                :
                                <option selected>No hay bancos disponibles</option>
                            }
                        </select>
                    </div>

                    {/* Es usuario para payfac */}
                    {loggedUser.isLafise && <div className="mb-3">
                        <label htmlFor="isPayfacUser" className="form-label">¿Es usuario Payfac?</label>
                        <select id='isPayfacUser' className="form-select" name='isUserPayfac' value={formState.isUserPayfac} onChange={onInputChange}>
                            <option key={0} value={'N'} >No</option>
                            <option key={1} value={'Y'}>Sí</option>
                        </select>
                    </div>}


                    {/* cargar payfacs */}
                    {formState.isUserPayfac == 'Y' && (
                        <div className={`mb-3 `}>
                            <label htmlFor="payfacSelect" className="form-label">Payfac</label>
                            <select id='payfacSelect' className="form-select" name='payfacId' value={formState.payfacId} onChange={onInputChange} >
                                <option key={0} value={-1} >Seleccione una opción</option>
                                {payfacs.length > 0
                                    ?
                                    payfacs.map(payfac => (
                                        <option key={payfac.id} value={payfac.id} selected={payfac.id == user.payfacId}>{payfac.name}</option>
                                    ))
                                    :
                                    <option selected>No hay payfacs disponibles</option>
                                }
                            </select>
                        </div>
                    )
                    }





                    <div className='container d-flex align-items-center justify-content-center mt-5'>
                        <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                        <button type="button" onClick={handleSave} className="btn btn-primary ms-5" disabled={!isFormValid}>Guardar</button>
                    </div>
                </form>
                <div style={{ height: '100px' }}></div>
            </div>

            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }
            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }
            {
                successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }

        </div>
    )
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
